import React, { useCallback, useContext, useEffect, useState } from 'react';
import _ from 'lodash';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import { TranslatorContext } from '@jutro/locale';
import { WizardPage, wizardProps } from 'gw-portals-wizard-react';
import { useDependencies } from 'gw-portals-dependency-react';
import { withAuthenticationContext } from 'gw-digital-auth-react';
import { ViewModelServiceContext } from 'gw-portals-viewmodel-react';
import { useValidation } from 'gw-portals-validation-react';
import { messages as paymentMessages } from 'gw-capability-policychange-common-react';
import metadata from './AddressPage.metadata.json5';
import './AddressPage.messages';
import AddressComponent from "../../../nexus-capability-gateway-react/Components/Address/AddressComponent";
import {AdditionalInsuredInterestComponent} from 'gw-capability-policychange-farm-react';
import { AccountContactSearchComponent } from '../../../nexus-capability-gateway-react';
import styles from './AddressPage.module.scss';

function AddressPage(props) {
    const translator = useContext(TranslatorContext);
    const {
        wizardData, updateWizardData, authHeader
    } = props;
    const { submissionVM } = wizardData;
    const viewModelService = useContext(ViewModelServiceContext);
    const { EndorsementService } = useDependencies('EndorsementService');
    const { initialValidation, isComponentValid, registerComponentValidation } = useValidation('AddressPage');
    const [accountContacts, setAccountContacts] = useState([{}]);
    const [isBmsClientCodeEditable, setIsBmsClientCodeEditable] = useState(true);

    const isAddressValid = useCallback(() => {
        if (
            (!submissionVM.baseData.policyAddress.aspects.valid || !submissionVM.baseData.policyAddress.aspects.subtreeValid)
        ) {
            return false;
        }
        return true;
    }, [submissionVM]);

    useEffect(() => {
        if(!_.get(submissionVM, 'baseData.termType.value')){
            submissionVM.baseData.termType.value = 'Annual';
        }
        submissionVM.baseData.policyAddress.isFromPortal.value = true
        const _contacts = submissionVM.baseData.account.accountContacts.value.map((c) => {
            c['id'] = c.publicID;
            return c;
        });
        _contacts.push({ id: "placeholder", displayName: "Search Existing Contacts" });
        setAccountContacts(_contacts);
        registerComponentValidation(isAddressValid);
    }, [registerComponentValidation, isAddressValid, submissionVM, setAccountContacts]);

    const writeValue = useCallback(
        (value, path) => {
            _.set(submissionVM, path, value);
            updateWizardData(wizardData);
        },
        [submissionVM, updateWizardData, wizardData]
    );

    /*const OnAddressValueChange = (value, path) => {
        const newLocationVM = viewModelService.clone(submissionVM.baseData.policyAddress);
        _.set(newLocationVM, path, value);
        writeValue(newLocationVM.value, 'baseData.policyAddress');
    }*/

    const onBrokerClientCodeChange = (value, index) => {
        const newSubmissionVM = viewModelService.clone(submissionVM);
        _.set(newSubmissionVM, `baseData.brokerClientCode.value`, value);
       _.set(wizardData, 'submissionVM', newSubmissionVM);
        updateWizardData(wizardData);
    };

    const onAddressChange = (value, path) => {
        const newLocationVM = viewModelService.clone(submissionVM.baseData.policyAddress);
        _.set(newLocationVM, path, value);
        writeValue(newLocationVM.value, 'baseData.policyAddress');
    }

    const onNext = useCallback(async () => {
        submissionVM.value = await EndorsementService.saveEndorsement(
            [submissionVM.value],
            authHeader
        );
        return wizardData;
    }, [EndorsementService, authHeader, submissionVM, wizardData]);

    const updateAdditionalInsured = (value, index) => {
        const newSubmissionVM = viewModelService.clone(submissionVM);
        _.set(newSubmissionVM, `baseData.additionalNamedInsureds.children.${index}.value`, value);
       _.set(wizardData, 'submissionVM', newSubmissionVM);
        updateWizardData(wizardData);
    }

    const writeAdditionalInsuredValue = useCallback(
        (value, path) => {
            _.set(submissionVM, `baseData.${path}`, value);
            _.set(wizardData, 'submissionVM', submissionVM);
            updateWizardData(wizardData);
        },
        [submissionVM, updateWizardData]
    );

    const updatePackage = (value, index) => {
        const newSubmissionVM = viewModelService.clone(submissionVM);
        updateWizardData(newSubmissionVM);
    };

    const updateSubmission = (newSubmissionVM) => {
        _.set(wizardData, 'submissionVM', newSubmissionVM);
        updateWizardData(wizardData);
    };

    const insureds = submissionVM.baseData.additionalNamedInsureds.value.map((c) => { return c.accountPublicId });
    const overrideProps = {
        '@field': {
            labelPosition: 'left',
            onValueChange: writeValue,
            showRequired: true
        },
        /*endorsementAddressLookup:{
            model: submissionVM.baseData.policyAddress,
            hideFields: ['addressLine3'],
            readOnlyFields: ['country'],
            onValueChange: OnAddressValueChange
        },*/
        endorsementAddressLookup: {
            model: submissionVM.baseData.policyAddress,
            //hideFields: ['addressLine3'],
            readOnlyFields: ['country'],
            onValueChange: onAddressChange
        },
        accountContactSearchId: {
            submissionVM: submissionVM,
            accountContacts: submissionVM.baseData.account.accountContacts,
            accountNumber: submissionVM.baseData.accountNumber,
            updatePackage: updatePackage,
            authHeader: authHeader,
            onValueChange: writeValue,
            updateWizardData: updateWizardData,
            isPolicyChange: true,
            updateSubmission: updateSubmission

        },
        additionalInsured: {
            coverableVM: submissionVM.baseData,
            accountContacts: accountContacts,
            accountNumber: submissionVM.baseData.accountNumber.value,
            type: 'additionalInsured',
            updatePackage: updateAdditionalInsured,
            authHeader: authHeader,
            onValueChange: writeAdditionalInsuredValue,
            isSubmission: false,
            jobID: submissionVM.jobID.value,
            updateAccountContacts: setAccountContacts,
            availableValues: submissionVM.baseData.account.accountContacts.value.filter( (c) => {
                return insureds.indexOf(c.publicID) == -1
            } ).map( (c) => {
                c['id'] = c.publicID;
                return c;
            }),
        },
        bmsClientCode: {
            visible : isBmsClientCodeEditable,
            readOnly : true,
            value: submissionVM.baseData.brokerClientCode.value ? submissionVM.baseData.brokerClientCode.value : null,
        },
        editBmsClientCode : {
            onClick : ()=>{
                setIsBmsClientCodeEditable(false);
            },
            visible : isBmsClientCodeEditable,
        },
        bmsClientCodeEditable : {
            visible : !isBmsClientCodeEditable,
            value: submissionVM.baseData.brokerClientCode.value ? submissionVM.baseData.brokerClientCode.value : null,
            onValueChange: onBrokerClientCodeChange,
            onBlur : ()=>{
                setIsBmsClientCodeEditable(true);
            },
        }
    };

    const resolvers = {
        resolveCallbackMap: {
        },
        resolveComponentMap: {
            /*addressLookupComponent: AddressLookupComponent*/
            addressComponent: AddressComponent,
            additionalInsuredInterestComponent: AdditionalInsuredInterestComponent,
            accountContactSearch: AccountContactSearchComponent
        },
        resolveClassNameMap: styles
    };

    return (
        <WizardPage
            onNext={onNext}
            disableNext={!isComponentValid}
            skipWhen={initialValidation}
            cancelLabel={translator(appConfig.persona === 'policyholder' ? paymentMessages.cancelAllChanges : paymentMessages.cancel)}
            showPrevious
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={submissionVM}
                overrideProps={overrideProps}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}
            />
        </WizardPage>
    );
}

AddressPage.propTypes = wizardProps;
export default withAuthenticationContext(AddressPage);
